/* The mockup's versions popover (`.ver-list`): a timeline, newest first, actions on the others. */
.list {
  max-block-size: 420px;
  margin: 0 calc(-1 * var(--space-4)) calc(-1 * var(--space-3));
  padding: var(--space-1);
  overflow-y: auto;
  border-top: 1px solid var(--border);
  list-style: none;
}

.none {
  display: inline-flex;
  align-items: center;
  block-size: 24px;
  padding: 0 var(--space-2);
  border: 1px solid var(--border);
  border-radius: var(--radius-pill);
  color: var(--text-muted);
  font-size: var(--font-size-12);
  white-space: nowrap;
}

/* Mockup v3 P4: the two ways back, said once above the list (v3 :2602). */
.help {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin: 0 0 var(--space-2);
  color: var(--text-muted);
  font-size: var(--font-size-12);
}

/* What the version cost (v3 `.ver-cost`), under its date: muted text (readable on the shown tint too). */
.cost {
  margin: 2px 0 0;
  color: var(--text-muted);
  font-size: var(--font-size-12);
  font-variant-numeric: tabular-nums;
}
